
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getDepartmentList, addDepartment, editorDepartment, delDepartment, batchDeleteDepartments } from '@/api/company';
import { exportDepartment, modifyDepartmentType } from '@/api/department';
import { getUserLimit } from '@/api/users';
import { UserModule } from '@/store/modules/user';
import { parseTime } from '@/utils/index';
import { lAreaData } from '@/const/LAreaData';
import { modifyDepartmentParent } from '@/api/department';
import { checkPermissionCompany } from '@/utils/permission';
import { Type } from '@/types/permissionType';
import { regular } from '@/const/regular';
import DialogLveReportDept from '@/components/DeptLev/index.vue';
import dialogSetStaff from './components/setStaff.vue';
import dialogSetInvite from './components/setInvite.vue';
import dialogSetImport from './components/setImport.vue';

@Component({
  name: 'StaffDepartment',
  components: {
    dialogSetStaff,
    dialogSetInvite,
    dialogSetImport,
    DialogLveReportDept
  }
})
export default class extends Vue {
  private formSearch: any = {
    deptmentType: '',
    deptmentName: '',
    area: ''
  }
  // 添加部门 1添加部门 2编辑部门 3添加下级
  private formDept:any = {
    type: 1,
    name: '',
    dept_code: '',
    area: '',
    sort: '',
    dept_pid: 0,
    serviceDept: false,
    spDept: false
  }
  // 列表内容
  private columnItemData: any = [
    { name: '部门名称', value: '0', checked: true },
    { name: '添加时间', value: '1', checked: true },
    { name: '省市区', value: '2', checked: true },
    { name: '操作', value: '3', checked: true }
  ]
  private settingColumnItem = false
  private isServer=false;
  private isSP = false
  private dialogAddDeptVisible = false
  // 省市区元数据
  private lAreaData = lAreaData;
  // 保存返回数据
  private selectAreaBean:any={}

  private defaultProps:any = {
    children: 'child',
    label: 'name',
    value: 'id'
  }
  private isSearchDept=false;
  // 1报修部门 2服务部门 3审批部门 4公共部门
  private deptmentTypeOptions: any = [
    { name: '报修部门', id: 1, value: '1', is_common: '0' },
    { name: '服务部门', id: 2, value: '2', is_common: '0' },
    { name: '公共部门', id: 3, value: '4', is_common: '1' },
    { name: '审批部门', id: 4, value: '3', is_common: '0' }
  ]
  private tableData = []
  private islazy = false
  private deptId = ''
  private enterType=1;
  private customHeight = window.innerHeight * 0.4;
  private rules = {
    name: [{ required: true, message: '请输入2-30位字母、中文、数字、-、_组成的部门名称', trigger: 'blur' }]
  };
  private dropdownOptions = [
    {
      name: '修改类型',
      funcname: 'modifyTypeHandle',
      level: 1
    },
    {
      name: '删除人员',
      funcname: 'deleteStaffHandle'
    },
    {
      name: '删除',
      funcname: 'deleteHandle'
    }
  ];

  private maps:any = new Map()

  private handleSearch() {
    this.selectedData = [];
    this.page = 1;
    this.isSearchDept = true;
    this.getDepartmentListAll();// 搜索是平铺数据
  }
  private handleClear() {
    this.selectedData = [];
    this.page = 1;
    this.isSearchDept = false;
    this.formSearch = {
      deptment: '',
      area: ''
    };
    this.getDepartmentList('', '', '');
  }

  private setColumnItem(val: any) {
    this.settingColumnItem = true;
  }
  private showHideColumn() {
    this.settingColumnItem = !this.settingColumnItem;
  }

  // 批量删除
  private selectedData:any = []
  private isSelectedAll = false;
  private handleSelecAllChange(val: any) {
    if (this.isSelectedAll) {
      this.clearAllRow(val);
    } else {
      this.checkAllRow(this.tableData);
    }
    this.isSelectedAll = !this.isSelectedAll;
    this.selectedData = (this.$refs.tableList as any).selection;
  }
  private handleSelectionChange(select: any, row: any) {
    let checkrow = [];
    checkrow.push(row);
    if (row.isCheck) {
      (this.$refs.tableList as any).toggleRowSelection(row, false);
      this.clearAllRow(checkrow);
    } else {
      (this.$refs.tableList as any).toggleRowSelection(row, true);
      this.checkAllRow(checkrow);
    }
    this.selectedData = (this.$refs.tableList as any).selection;
  }
  private clearAllRow(data: any) {
    Array.from(data).forEach((row:any) => {
      row.isCheck = false;// 给这行数据设置一个选中字段为false
      (this.$refs.tableList as any).toggleRowSelection(row, false);
      if (row.children && row.children.length > 0) this.clearAllRow(row.children);// 有子集就递归  没子集了就不循环了
    });
  }
  private checkAllRow(data:any) {
    Array.from(data).forEach((row:any) => {
      row.isCheck = true;// 选中是字段值为true
      (this.$refs.tableList as any).toggleRowSelection(row, true);
      if (row.children && row.children.length > 0) this.checkAllRow(row.children);
    });
  }
  private groupDelete() {
    if (!this.selectedData || this.selectedData.length === 0) {
      this.showErrorMsg('请选择部门');
      return;
    }
    this.$confirm('删除上级会把下级删除', '是否批量删除?', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        this.delGroupUsers();
      })
      .catch(() => {});
  }
  private delGroupUsers() {
    this.clearAll();
    let arr:any = [];
    this.selectedData.forEach((u:any) => {
      let dept:any = {};
      dept.id = u.id;
      dept.name = u.name;
      arr.push(dept);
    });

    let pamars:any = {};
    pamars.company_id = UserModule.getCompanyId;
    pamars.user_id = UserModule.getUserId;
    pamars.departments = JSON.stringify(arr);
    batchDeleteDepartments(pamars).then((res:any) => {
      this.showSecussMsg(res.msg);
      this.tableData = [];
      if (this.isSearchDept) {
        this.getDepartmentListAll();
      } else {
        this.getDepartmentList('', '', '');
      }
      this.getUserLimit();
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
    // 导出Excel
  private handleExport() {
    let params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      user_name: UserModule.getUserName,
      company_name: UserModule.getCompanyName,
    };
    exportDepartment(params).then(res => {
      this.$confirm('是否跳转下载页面？', '跳转', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let routeData = this.$router.resolve({
          path: '/ExportTask',
          query: {}
        });
        window.open(routeData.href);
      }).catch(() => {

      });
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

   // 修改上级
  // 选择上级
   private deptSuperiorHandle() {
    if (this.selectedData.length === 0) {
      this.$notify({
        title: '提示',
        message: '请选择需要修改上级的部门',
        type: 'warning'
      });
      return;
    }
    this.selectSelfDept();
  }
  private companyId = UserModule.getCompanyId;
  private selfDepartmentLevVisible=false
  private selectDept = {department_id:0,department_type:0}
  private selectSelfDept() {
    this.selfDepartmentLevVisible = true;
  }
  private selectSelfDeptLev(value:any) {
    this.selectDept.department_id = value.dept_id;
    this.selectDept.department_type = value.dept_type;
  }
  private handleLveSelfDeptConfirm() {
    let ids :any = [];
    if( this.selectDept.department_id === 0) {
      this.showErrorMsg('请选择上级部门！');
      return;
    }
    this.selectedData.forEach((item:any) => {
      ids.push(item.id);
    });
    let deptNotSame = this.selectedData.find((item:any) => item.dept_type !== this.selectDept.department_type);
    if(deptNotSame){
      this.showErrorMsg('部门类型不一致，请重新选择！');
      return;
    }
    //判断如果部门类型不一致报错
    let pamars:any = {};
    pamars.user_id = UserModule.getUserId;
    pamars.company_id = UserModule.getCompanyId;
    pamars.dept_ids = ids;
    pamars.dept_pid = this.selectDept.department_id;
    modifyDepartmentParent(pamars).then((res:any) => {
      this.selfDepartmentLevVisible = false;
      this.showSecussMsg(res.msg);
      this.tableData = [];
      if (this.isSearchDept) {
        this.getDepartmentListAll();
      } else {
        this.getDepartmentList('', '', '');
      }
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
    this.selectedData = [];
    this.closeDialogLveSelfDept();
  }
  private closeDialogLveSelfDept() {
    this.selectDept.department_id = 0;
    this.selectDept.department_type = 0;
    this.selfDepartmentLevVisible = false;
  }

  private dialogSetStaffVisible = false
  // 修改类型弹窗
  private dialogModifyTypeVisible = false
  private modifyTypeForm: any = {
    dept_id: '',
    serviceDept: false
  }
  // 修改类型处理函数
  private modifyTypeHandle(val: any) {
    this.modifyTypeForm = {
      dept_id: val.dept_id,
      serviceDept: parseInt(val.dept_type) === 2
    };
    this.dialogModifyTypeVisible = true;
  }
  // 关闭修改类型弹窗
  private closeModifyType() {
    this.dialogModifyTypeVisible = false;
    this.modifyTypeForm = {
      dept_id: '',
      serviceDept: false
    };
  }
  // 确认修改类型
  private confirmModifyType() {
    let params: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      dept_id: this.modifyTypeForm.dept_id,
      dept_type: this.modifyTypeForm.serviceDept ? 2 : 1
    };
    let _this = this;
    modifyDepartmentType(params).then((res: any) => {
      //方法一刷新子集部门
      // _this.clearAll();
      // 刷新列表
      if (_this.isSearchDept) {
        _this.getDepartmentListAll();
      } else {
        _this.getDepartmentList('', '', '');
      }
      //方法一  _this.refData(_this.modifyTypeForm.dept_id);
      //第二种，用下面的代码，可以在添加完子节点操作后，收起所有的节点（不展开）：
      //https://blog.csdn.net/qq_49137582/article/details/129272753
      _this.$set(((this.$refs.tableList) as any).store.states, "lazyTreeNodeMap", {});
      _this.$set(((this.$refs.tableList) as any).store.states, "treeData", {});

      _this.showSecussMsg(res.message || '修改成功');
      _this.closeModifyType();
    }).catch((err: any) => {
      this.showErrorMsg(err.msg || err.message || '修改失败');
    });
  }
  private deleteStaffHandle(val:any) {
    this.enterType = 2;
    this.deptId = val.dept_id;
    this.dialogSetStaffVisible = true;
  }
  private addStaffHandle(val:any) {
    this.enterType = 1;
    this.deptId = val.dept_id;
    this.dialogSetStaffVisible = true;
  }
  private spDeptChange(val:boolean) {
    if (val) {
      this.$set(this.formDept, 'serviceDept', false)
    }
  }
  private serviceDeptChange(val:boolean) {
    if (val) {
      this.$set(this.formDept, 'spDept', false)
    }
  }
  closeHandle(value: boolean) {
    if (this.isSearchDept) {
      this.getDepartmentListAll();
    } else {
      this.getDepartmentList('', '', '');
    }
    this.dialogSetStaffVisible = value;
  }
  private addDeptClose() {
    this.dialogAddDeptVisible = false;
    this.formDept = {
      type: 1,
      name: '',
      dept_code: '',
      area: '',
      sort: '',
      dept_pid: 0,
      serviceDept: ''
    };
  }

  private lev = 2;
  private editorStaffHandle(val:any) {
    this.dialogAddDeptVisible = true;
    this.formDept = {
      type: 2,
      dept_id: val.dept_id,
      dept_pid: val.dept_pid ? val.dept_pid : 0,
      name: val.name,
      dept_code: val.dept_code,
      sort: val.sort,
      area: [val.province, val.city, val.district],
      serviceDept: parseInt(val.dept_type) === 2,
      spDept: parseInt(val.dept_type) === 3,
      publicDept: parseInt(val.is_common) === 1,
      province: val.province,
      province_name: val.province_name,
      city: val.city,
      city_name: val.city_name,
      district: val.district,
      district_name: val.district_name,
      lower_level_count: val.lower_level_count

    };
  }
  private deleteHandle(val:any) {
    let _this = this;
    this.$confirm('确认删除吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        _this.delStaffDepartment(val.dept_id, val.dept_pids, val.hasChildren);
      })
      .catch(() => {});
  }

  // type 1 = add 2 = delete
  private refDataList(pids:any, type:number, hasChildren:boolean) {
    let list = pids.split(',');
    let _ = this;
    if (list) {
      if (hasChildren) {
        _.refData(list[list.length - 1]);
      } else {
        _.refData(list[list.length - 1]);
        _.refData(list[list.length - 2]);
      }
    }
  }

  private refData(pid:any) {
    if (this.maps.get(pid)) {
      this.$set(((this.$refs.tableList) as any).store.states.lazyTreeNodeMap, pid, []);
      const { tree, treeNode, resolve } = this.maps.get(pid);
      this.load(tree, treeNode, resolve);
    }
  }

  private clearAll() {
    var _ = this;
    this.maps.forEach(function(v:any, k:any, m:any) {
      _.$set(((_.$refs.tableList) as any).store.states.lazyTreeNodeMap, k, []);
    });
  }

  private formDeptHandle() {
    (this.$refs.ruleForm as any).validate((valid: any) => {
      if (valid) {
        this.addStaffDepartment();
      } else {
        return false;
      }
    });
  }
  private addDeptHandle() {
    this.formDept = {
      type: 1,
      name: '',
      dept_code: '',
      area: '',
      sort: '',
      dept_pid: 0,
      serviceDept: '',
      spDept: "",
      lower_level_count: 0
    };
    this.dialogAddDeptVisible = true;
  }

  private addBubordinateDeptHandle(val:any) {
    this.dialogAddDeptVisible = true;
    this.formDept = {
      type: 3,
      pname: val.name,
      pid: val.id,
      pids: val.dept_pids + ',' + val.id,
      hasChildren: val.hasChildren,
      dept_code: '',
      //20240912 父级是什么子级就是什么 true代表维修部
      serviceDept: parseInt(val.dept_type) === 2,
    };


  }

  private setImportVisible = false
  private setImportTitle='导入部门'
  importHandle() {
    this.setImportVisible = true;
  }
  closeImport(value: boolean) {
    this.setImportVisible = value;
    this.getDepartmentList('', '', '');
  }
  private limitString='';
  created() {
    let body = document.documentElement || document.body;
    body.addEventListener('click', (e: any) => {
      if (e.target.id !== 'getColumnItembutton') {
        this.settingColumnItem = false;
      }
    }, false);

    let vipLevel = (UserModule.getCompany as any).vip_level;
    this.isServer = vipLevel.substr(0, 1) !== '1';
    this.isSP = checkPermissionCompany(UserModule.getCompanyId, Type.SP);
    this.getDepartmentList('', '', '');
    this.getUserLimit();
  }
  private page=1;
  private total=0;
  private pageSize=10;
  private handlePageSizeChange(size:number) {
    this.pageSize = size;
    if (this.isSearchDept) {
      this.getDepartmentListAll();
    } else {
      this.getDepartmentList('', '', '');
    }
  }
  private handleCurrentChange(page:number) {
    this.page = page;
    if (this.isSearchDept) {
      this.getDepartmentListAll();
    } else {
      this.getDepartmentList('', '', '');
    }
  }
  private handBtngroupMore(name:any, row:any) {
    (this.$options as any).methods[name].bind(this)(row);
  }

  load(tree:any, treeNode:any, resolve:any) {
    const parentId = tree.id;
    this.maps.set(parentId, { tree, treeNode, resolve });
    this.getDepartmentList(tree.id, tree, resolve);
  }

  private getDepartmentList(deptPid: any, tree:any, resolve:any) {
    const params:any = {
      company_id: UserModule.getCompanyId,
      type: '9', // type=9 查所有部门  type=2查服务部门
      is_show_user_count: 1,
      is_multi_level: 1,
      dept_pid: deptPid,
      is_department_list: 1
    };
    if (deptPid) {
      params.page = 1;
      params.size = 9999;
    } else {
      params.page = this.page;
      params.size = this.pageSize;
    }
    if (this.formSearch.deptmentName) {
      params.name = this.formSearch.deptmentName;
    }
    if (this.formSearch.area) {
      params.address = this.formSearch.area;
    }
    if (this.formSearch.deptmentType) {
      params.is_common = this.formSearch.deptmentType.is_common;
    }
    getDepartmentList(params)
      .then(res => {
        if (deptPid) {
          if (res.data && res.data.list) {
            this.lev = 2;
            let dataTable:any = res.data.list;
            tree.children = dataTable;
            dataTable.forEach((item:any) => {
              (item as any).hasChildren = parseInt(item.lower_level_count) > 0;
              (item as any).level = item.dept_pids ? parseInt(item.dept_pids.split(',').length + 1) : 1;
            });
            resolve(dataTable);
            this.paseData(dataTable);
          } else {
            resolve([]);
          }
        } else {
          if (res.data && res.data.list) {
            res.data.list.forEach((item:any) => {
              (item as any).hasChildren = parseInt(item.lower_level_count) > 0;
              (item as any).level = item.dept_pids ? parseInt(item.dept_pids.split(',').length + 1) : 1;
            });
            let arr = res.data.list.filter((v: any) => {
              return v.hasChildren === true;
            });
            if (arr && arr.length > 0) { this.islazy = true; } else { this.islazy = false; }
            this.total = res.data.count;
            this.tableData = res.data.list;
            this.paseData(this.tableData);
          } else {
            this.total = 0;
            this.tableData = [];
          }
        }
      })
      .catch(err => {
        let msg = err.msg;
      });
  }

  private getDepartmentListAll() {
    const params: any = {
      company_id: UserModule.getCompanyId,
      type: this.formSearch.deptmentType
        ? this.formSearch.deptmentType.value
        : '9', // type=9 查所有部门  type=2查服务部门
      page: this.page,
      size: this.pageSize,
      dept_pid: 0,
      is_department_list: 1,
      is_full_path_pnames: this.isSearchDept ? 1: 0,
    };
    if (this.formSearch.deptmentName) {
      params.name = this.formSearch.deptmentName;
    }
    if (this.formSearch.area) {
      params.address = this.formSearch.area;
    }
    if (this.formSearch.deptmentType) {
      params.is_common = this.formSearch.deptmentType.is_common;
    }
    getDepartmentList(params)
      .then((res) => {
        if (res.data) {
          this.tableData = res.data.list;
          this.total = res.data.count;
          this.paseData(this.tableData);
        } else {
          this.total = 0;
          this.tableData = [];
        }
      })
      .catch((err) => {
        let msg = err.msg;
      });
  }

  // 添加部门
  private addStaffDepartment() {
    let _this = this;
    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.name = this.formDept.name;
    params.dept_code = this.formDept.dept_code;
    //调用正规表达式校验
    if(!regular.departmentName.pattern.test( params.name)){
      // this.rules.name.message 
      this.showErrorMsg("请输入2-30位字母、中文、数字、-、_组成的部门名称");
      return;
    }

    params.dept_type = this.formDept.serviceDept ? '2' : this.formDept.spDept ? '3' : '1';
    if (this.formDept.serviceDept) {
      params.is_common = this.formDept.publicDept ? '1' : '0';
    }
    params.sort = this.formDept.sort;
    params.province = this.selectAreaBean.province;
    params.province_name = this.selectAreaBean.province_name;
    params.city = this.selectAreaBean.city;
    params.city_name = this.selectAreaBean.city_name;
    params.district = this.selectAreaBean.district;
    params.district_name = this.selectAreaBean.district_name;
    params.vip_level = (UserModule.company as any).vip_level;
    switch (parseInt(this.formDept.type)) {
      case 1:
        params.hasChildren = false;
        _this.addDept(params);
        break;
      case 2:
        _this.editDept(params);
        break;
      case 3:
        params.dept_pid = this.formDept.pid;
        params.dept_pids = this.formDept.pids;
        params.hasChildren = this.formDept.hasChildren;
        _this.addDept(params);
        break;
    }
  }

  private addDept(params:any) {
    let _this = this;
    addDepartment(params)
      .then((res:any) => {
        _this.showSecussMsg(res.msg);
        _this.dialogAddDeptVisible = false;
        _this.formDept = {
          type: 1,
          name: '',
          dept_code: '',
          area: '',
          sort: '',
          dept_pid: 0,
          serviceDept: ''
        };
        if (_this.isSearchDept) {
          _this.getDepartmentListAll();
        } else {
          _this.getDepartmentList('', '', '');
        }
        if (params.dept_pid) {
          _this.refDataList(params.dept_pids, 1, params.hasChildren);
        }
        _this.getUserLimit();
      })
      .catch((err) => {
        _this.showErrorMsg(err.msg);
      });
  }

  private editDept(params:any) {
    let _this = this;
    params.id = this.formDept.dept_id;
    editorDepartment(params)
      .then((res:any) => {
        if (_this.isSearchDept) {
          _this.getDepartmentListAll();
        } else {
          _this.getDepartmentList('', '', '');
        }
        if (this.formDept.dept_pid) {
          _this.refDataList(this.formDept.dept_pid, 1, params.hasChildren);
        }
        _this.showSecussMsg(res.msg);
        _this.dialogAddDeptVisible = false;
        _this.formDept = {
          name: '',
          dept_code: '',
          area: '',
          sort: '',
          dept_pid: 0,
          serviceDept: ''
        };
      })
      .catch((err) => {
        _this.showErrorMsg(err.msg);
      });
  }

  // 删除部门
  private delStaffDepartment(id:string, pids:String, hasChildren:boolean) {
    let _this = this;
    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.id = id;
    delDepartment(params).then((res:any) => {
      _this.showSecussMsg(res.msg);
      if (_this.isSearchDept) {
        _this.getDepartmentListAll();
      } else {
        _this.getDepartmentList('', '', '');
      }
      this.getUserLimit();
      _this.refDataList(pids, 2, hasChildren);
    }).catch(err => {
      _this.showSecussMsg(err.msg);
    });
  }

  // --------版本限制---------
  private userLimit:any = {
    dept_number: '0',
    all_dept_num: '0'
  };
  // 版本人数限制
  getUserLimit() {
    const params = {
      company_id: UserModule.getCompanyId
    };
    getUserLimit(params)
      .then(res => {
        if (res.data) {
          this.userLimit = res.data;
          if (this.isServer) {
            this.limitString = '当前版本可添加部门总数' + this.userLimit.dept_number + '个，其中服务部门' +
            this.userLimit.dept_service_number + '个；现已添加部门总数' + this.userLimit.all_dept_num + '个，其中服务部门' +
            this.userLimit.ser_dept_num + '个。';
          } else {
            this.limitString = '当前版本可添加部门总数' + this.userLimit.dept_number + '个；现已添加部门总数' + this.userLimit.all_dept_num + '个。';
          }
          //   'repair_see_order_number'   => 报修查看订单数量
          // 'rso_num' => 报修查看报修单人数

          //          'dept_number'   => 部门数量
          // 'all_dept_num' => 当前公司部门总数
        }
      })
      .catch(err => {
        let msg = err.msg;
      });
  }
  paseData(val:any) {
    for (let i = 0; i < val.length; i++) {
      let cont:any = val[i];
      cont.area = val[i].province_name + val[i].city_name + val[i].district_name;
      cont.addTimeStr = parseTime(cont.addtime, '{y}-{m}-{d} {h}:{i}');
      this.$set(this.tableData, cont, i);
    }
  }

  // 添加部门省市区选择
  private changeHandle(value: any) {
    if (this.formDept.area) {
      this.selectAreaBean = {
        province: this.formDept.area[0],
        province_name: (this.$refs.myCascader as any).getCheckedNodes()[0].pathLabels[0],
        city: this.formDept.area[1],
        city_name: (this.$refs.myCascader as any).getCheckedNodes()[0].pathLabels[1],
        district: this.formDept.area[2],
        district_name: (this.$refs.myCascader as any).getCheckedNodes()[0].pathLabels[2],
        adcode: (this.$refs.myCascader as any).getCheckedNodes()[0].data.adcode
      };
    }
  }

  // 邀请人员
  private dialogInviteVisible = false
  private dialogInviteDept = true

  inviteHandle() {
    this.dialogInviteVisible = true;
  }
  closeInvite(value: boolean) {
    this.dialogInviteVisible = value;
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }
}
